import React, { useEffect, useState } from "react";
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from "reactstrap";
import { SuccessOk } from "configs/statusCode";
import {
	AvForm,
	AvField,
	AvRadioGroup,
	AvRadio,
} from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import ResaleService from "services/Admin/ResaleService";

function ModalForm({ modal, toggle, setShouldGetData, editResale }) {
	const service = new ResaleService();
	const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState({
		description: "",
		status: "",
	});

	useEffect(() => {
		setFormData({
			description: "",
			status: editResale?.status,
		});
	}, [editResale]);

	const handleFieldChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleValidSubmit = (_, values) => {
		setLoading(true);
		const data = {
			status: formData.status,
		};
		if (formData.status === "Rejected") data["message"] = formData.description;
		service.updateStatus(editResale.id, data).then((res) => {
			if (res && res.status === SuccessOk) {
				setShouldGetData((prev) => !prev);
				toast.success("Sucessffuly updated");
				toggle();
			} else {
				setLoading(false);
			}
		});
	};
	return (
		<Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
			<ModalHeader toggle={toggle}>updating Resale Status</ModalHeader>
			<ModalBody>
				<AvForm
					className="form-horizontal"
					onValidSubmit={(e, v) => {
						handleValidSubmit(e, v);
					}}>
					<Row className="mb-2">
						<AvRadioGroup
							name="status"
							value={formData.status}
							required
							onChange={handleFieldChange}>
							<AvRadio label="Live" value="Live" />
							<AvRadio label="Pending" value="Pending" />
							<AvRadio label="Sold" value="Sold" />
							<AvRadio label="Rejected" value="Rejected" />
							<AvRadio label="Not Available" value="Not_Available" />
						</AvRadioGroup>
					</Row>
					{formData.status === "Rejected" && (
						<Row>
							<Col md={12}>
								<AvField
									className="mb-3"
									name={"description"}
									label={`Rejection Reasons`}
									value={formData.description}
									onChange={(e) => handleFieldChange(e)}
									bsSize="lg"
									required
									type="textarea"
									placeholder={"Type reasons of rejection"}
								/>
							</Col>
						</Row>
					)}
					<ModalFooter className="px-0">
						<button
							type="submit"
							size={"lg"}
							disabled={loading ? true : false}
							className="btn btn-success w-100">
							Update Status
						</button>
					</ModalFooter>
				</AvForm>
			</ModalBody>
		</Modal>
	);
}

export default ModalForm;
